import { ExpandLess, ExpandMore } from '@mui/icons-material';
import {
  Collapse,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { styles } from './styles';

import type { SvgIconComponent } from '@mui/icons-material';

interface INavItemProps {
  path: string;
  name?: string;
  icon: SvgIconComponent;
  children?: INavItemProps[];
}

const NavItem: React.FC<INavItemProps> = ({ path, name, icon: Icon, children }) => {
  const navigate = useNavigate();

  const hasChildren = !!children;
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const onItemClick = () => {
    if (!hasChildren) {
      navigate(path);
    }
  };

  return (
    <>
      <ListItem key={name} disablePadding onClick={handleClick}>
        <ListItemButton onClick={onItemClick}>
          <ListItemIcon>
            <Icon sx={styles.icon} />
          </ListItemIcon>
          <ListItemText primary={name} sx={styles.listItem} />
          {hasChildren && (
            <>{open ? <ExpandLess sx={styles.icon} /> : <ExpandMore sx={styles.icon} />}</>
          )}
        </ListItemButton>
      </ListItem>
      {hasChildren && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={styles.list}>
            {children.map((item) => (
              <NavItem {...item} key={item.name} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

export default NavItem;
